import { Icon, Label, mergeStyles, Stack } from '@fluentui/react';

import React from 'react';

export const iconClass = mergeStyles({
	fontSize: 14,
	height: 18,
	width: 18,
	color: 'black',
	cursor: 'help',
	margin: '6px !important',
});

export interface IInfoTooltipLabelProps {
	title: string;
	label: string;
	horizontal?:boolean;
}

export class InfoTooltipLabel extends React.Component<IInfoTooltipLabelProps> {
	public render() {
		return (
			<Stack horizontal={this.props.horizontal}>

				{this.props.horizontal && 
					<Stack.Item>
						{this.props.children}
					</Stack.Item>
				}


				<Stack.Item>
					<Stack horizontal style={{width:'100%'}}>
						<Label>{this.props.label}</Label>
						<Icon title={this.props.title} iconName="Info" className={iconClass}></Icon>
					</Stack>
				</Stack.Item>


				{!this.props.horizontal && 
					<Stack.Item>
						{this.props.children}
					</Stack.Item>
				}
			</Stack>
		);
	}
}
